import { render, staticRenderFns } from "./SchoolDataMigrationPanel.vue?vue&type=template&id=1b05f996&scoped=true"
import script from "./SchoolDataMigrationPanel.vue?vue&type=script&lang=js"
export * from "./SchoolDataMigrationPanel.vue?vue&type=script&lang=js"
import style0 from "./SchoolDataMigrationPanel.vue?vue&type=style&index=0&id=1b05f996&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b05f996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b05f996')) {
      api.createRecord('1b05f996', component.options)
    } else {
      api.reload('1b05f996', component.options)
    }
    module.hot.accept("./SchoolDataMigrationPanel.vue?vue&type=template&id=1b05f996&scoped=true", function () {
      api.rerender('1b05f996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/other/SchoolDataMigrationPanel.vue"
export default component.exports